import React from 'react';
import { useSelector } from 'react-redux';

import { SIZE_SMALL } from '@/mui/constants';

import { useTranslate } from '@/modules/common/helpers/i18n';
import * as commonSelectors from '@/modules/common/redux/selectors/common';

import { Chip, Tab, Tabs } from '@/mui/components';

import styles from './Chips.module.scss';

type Props = {
  className?: string;
};
function ChipsSkeleton({ className = '' }: Props) {
  const configuration = useSelector(commonSelectors.configurationSelector);
  const t = useTranslate();

  const countOfChips = Math.ceil((window.innerWidth * 0.7) / 100);
  const chipSize = configuration.common.chips.size ?? SIZE_SMALL;

  return (
    <div className={className}>
      <Tabs
        size="small"
        variant="scrollable"
        value=""
        allowScrollButtonsMobile
        classes={{
          root: styles.TabsRoot,
          list: styles.TabsList,
          indicator: styles.TabsIndicator,
        }}
      >
        <Tab
          label={
            <Chip
              label={t.allChips.text()}
              size={chipSize}
              color="neutral"
              variant="filled"
              className={styles.Chip}
              classes={{
                label: styles.ChipLabel___plug,
              }}
              onClick={() => null}
            />
          }
          value=""
          disableRipple
          className={styles.Tab}
        />
        {new Array(countOfChips).fill(null).map((_, index) => {
          const key = `key-${index}`;

          return (
            <Tab
              key={key}
              label={
                <Chip
                  label="------------------------"
                  size={chipSize}
                  color="neutral"
                  variant="filled"
                  className={styles.Chip}
                  classes={{
                    label: styles.ChipLabel___plug,
                  }}
                  onClick={() => null}
                />
              }
              value={key}
              disableRipple
              className={styles.Tab}
            />
          );
        })}
      </Tabs>
    </div>
  );
}

export default ChipsSkeleton;
